module.exports = __webpack_public_path__ + "img/pageinteriors_04asesoria-en-siniestros-01.d02cfd23.jpg";